<template>
  <svg
    id="house-black-silhouette-without-door"
    xmlns="http://www.w3.org/2000/svg"
    width="30.885"
    height="29.9"
    viewBox="0 0 30.885 29.9"
  >
    <path
      id="Path_1538"
      data-name="Path 1538"
      d="M30.5,19.478a1.473,1.473,0,0,0-.121-2.107L16.574,5.294a1.721,1.721,0,0,0-2.244.026L.48,18.015a1.464,1.464,0,0,0-.067,2.1l.347.362a1.514,1.514,0,0,0,2.078.159l1.035-.927v13.57A1.506,1.506,0,0,0,5.381,34.79h5.4a1.506,1.506,0,0,0,1.507-1.507V23.79h6.886v9.494a1.424,1.424,0,0,0,1.415,1.506h5.721a1.506,1.506,0,0,0,1.507-1.507V19.9l.639.56c.352.309,1.092.061,1.651-.555Z"
      transform="translate(0 -4.89)"
      :fill="color"
    />
  </svg>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Home_Icon",
  props: {
    color: {
      default: "#1C274C",
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState("defaultSystem", ["site"]),
  },
};
</script>


<style>
</style>